import { getQueryKeys } from "../../helper";

export const namespace = "virtual-accounts";

export default {
  ...getQueryKeys(namespace),
};
